export class FactSliderModalController {
  constructor($scope, $modalInstance, $timeout) {
  }

}



// WEBPACK FOOTER //
// ./src/facts/slider/facts-slider-modal.component.js